// based on the code from EngageTaskManagerWidget.js
import { monitorTask } from '../tasks.util'

const genericMapping = {
  NOT_FOUND: 'GENERIC_NOT_FOUND',
  MISSING_PARAMETER: 'GENERIC_MISSING_PARAMETER',
  FAILED_VALIDATION: 'GENERIC_FAILED_VALIDATION',
  FAILED_SEND: 'GENERIC_FAILED_SEND',
  EXECUTION_FAILED: 'GENERIC_EXECUTION_FAILED',
  ALREADY_EXISTS: 'GENERIC_ALREADY_EXISTS',
  PARTLY_COMPLETED: 'GENERIC_PARTLY_COMPLETED',
  MISSING_TANGIBLES: 'GENERIC_MISSING_TANGIBLES',
  FAILURE: 'GENERAL.CONTACT_SUPPORT',
  INVALID_AUTHENTICATION_TOKEN: 'GENERAL.INVALID_AUTHENTICATION_TOKEN',
}

// Takes the error code and translates it into the error message
const translateMessage = (errorCode, intl) => {
  // Translate the error code into a specified message depending on the task
  const overwrittenMappings = Object.assign(genericMapping)
  const mappedId = overwrittenMappings[errorCode]

  if (mappedId) {
    const translatedMessage = intl.formatMessage({ id: mappedId })

    // Error code was found
    if (translatedMessage) {
      return translatedMessage
    }
  }

  // Return a generic default error if we get here
  return intl.formatMessage({ id: 'GENERAL.ERROR' })
}

const useTaskManagementMonitor = () => {
  const triggerTaskManagementMonitor = async (customerId, taskId, errorMappings, intl, monitorTaskLimit) => {
    const { result, error } = await monitorTask(customerId, taskId, monitorTaskLimit)

    // Handle the error as needed via errorMappings, setState, intl
    if (error && error.isErrorCode) {
      error.StatusMessage = translateMessage(error.StatusMessage, errorMappings, intl)
    }

    return { error, result }
  }

  return { triggerTaskManagementMonitor }
}

export { useTaskManagementMonitor }
